import { render, staticRenderFns } from "./CompensationDistDeptComponent.vue?vue&type=template&id=61c3ef02&"
import script from "./CompensationDistDeptComponent.vue?vue&type=script&lang=js&"
export * from "./CompensationDistDeptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports